import { axiosConfig } from './axios-config.js'

export const user = {
  // 取得使用者
  get: (id, token) => axiosConfig.get(`/api/console/user/${id}`, token),

  // 創建使用者
  create: (data, token) => axiosConfig.post('/api/console/user', data, token),

  // 更新使用者
  update: (id, data, token) => axiosConfig.patch(`/api/console/user/${id}`, data, token)
}
